export const typeformUrl = 'https://welltory.typeform.com/to/aRmLydDr';
